export default __webpack_public_path__ + "static/media/KidsPlayArea.18573388.webp";